import GenericCrudService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudService";
import WorkLogMonthly from "../models/WorkLogMonthly";
import environment from "../environment.json";
import HttpClient from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClient";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";

class WorkLogMonthlyService extends GenericCrudService<WorkLogMonthly> {
  path: string;

  constructor(path: string) {
    super(path);
    this.path = path;
  }

  async lockReport(project: String, date:Date, isLocked:Boolean): Promise<any> {
    const url: string = `${environment.baseURL}${this.basePath}/lock-report`;
    return await HttpClientV2.post(url, {projectExternalId:project, firstDayOfMonth:date, locked:isLocked});
  }

  async getByDateAndProject(project: String, year: number, month: number): Promise<any> {
    const url: string = `${environment.baseURL}${this.basePath}/get-by-date-and-project?year=${year}&month=${month}&projectExternalId=${project}`;
    return await HttpClient.get(url);
  }

}

export default new WorkLogMonthlyService("/ensolvers-ops/work-log-monthly");
